import CssBaseline from '@material-ui/core/CssBaseline';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { themeColors } from 'Theme';
import React from 'react';


export const theme = createTheme({
  overrides: {
    MuiSnackbar: {
      root: {
        backgroundColor: '#0033A0',
        borderRadius: '4px',
      },
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: '#0033A0',
      },
    },
    MuiPaper: {
      root: {
        color: themeColors.gray_700,
      }
    },
    MuiButton: {
      containedPrimary: {
        color: themeColors.primaryWhite,
        backgroundColor: themeColors.blue_400,
        '&:hover': {
          backgroundColor: themeColors.brightBlue_300,
          color: themeColors.primaryWhite,
        },
      },
      textPrimary: {
        color: themeColors.blue_400,
      },
      root: {
        color: themeColors.blue_400,
        '&:disabled': {
          color: themeColors.gray_300,
        },
        '&:hover': {
          color: themeColors.blue_400,
          backgroundColor: themeColors.gray_50T,
        }
      },
      contained: {
        color: themeColors.gray_800,
        backgroundColor: themeColors.gray_100,
        '&:hover': {
          backgroundColor: themeColors.gray_70,
          color: themeColors.gray_800,
        },
        '&:disabled': {
          backgroundColor: themeColors.blue_200,
          color: themeColors.primaryWhite,
        }
      },
      label: {
        fontSize: 12,
      },
    },
    MuiButtonBase: {
      root: { color: themeColors.gray_700 }
    },
    MuiAppBar: {
      colorPrimary: {
        color: themeColors.primaryWhite,
        backgroundColor: themeColors.blue_400,
      }
    },
    MuiFab: {
      primary: {
        color: themeColors.primaryWhite,
        backgroundColor: themeColors.blue_400,
        '&:hover': {
          backgroundColor: themeColors.brightBlue_300,
          color: themeColors.primaryWhite,
        },
      },
    },
    MuiStepIcon: {
      active: {
        color: themeColors.Secondary,
      },
    },
    MuiFormLabel: {
      root: {
        color: themeColors.gray_700,      },
    },
    MuiMenuItem: {
      root: {
        fontSize: 14,
      },
    },
    MuiCheckbox: {
      root: {
        color: themeColors.gray_700,
      },
      colorPrimary: {
        '&$checked': {
          color: themeColors.blue_400,
        },
      },
      colorSecondary: {
        '&$checked': {
          color: themeColors.brightBlue_300,
        },
      }
    },
    MuiChip: {
      outlinedPrimary: {
        color: themeColors.blue_400,
        border: '1px solid ' + themeColors.blue_400,
      },
      deleteIconOutlinedColorPrimary: {
        color: themeColors.blue_200,
        '&:active': {
          color: themeColors.blue_400,
        },
        '&:hover': {
          color: themeColors.blue_400,
        },
      }
    }
  },
  palette: {
    primary: {
      main: themeColors.Primary,
    },
    secondary: {
      contrastText: '#0033A0',
      main: '#FF9E16',
    },
    type: 'light',
  },
  typography: {
    // fontFamily: '"AllstateObjektiv", Arial',
    fontFamily: '"Roboto", sans-serif',
    body1: {
      fontSize: 14,
    },
    body2: {
      fontSize: 16,
    },
  },
});

const WithTheme = <TProps extends {}>(Component: React.ComponentClass<TProps> | React.FunctionComponent<TProps>) => (
  props: TProps
) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Component {...props} />
  </ThemeProvider>
);

export default WithTheme;
